class Tabs {
    #activeTab = null;
    #tabItems;

    constructor(tabItems) {
        this.#tabItems = tabItems;
        for (const tab of tabItems) {
            if (tab.getAttribute('aria-selected') === 'true') {
                this.setActiveTab(tab);
            }
        }

        if (this.#activeTab === null) {
            this.setActiveTab(tabItems[0]);
        }

        for (const tab of this.#tabItems) {
            tab.addEventListener('click', () => this.setActiveTab(tab));

            // Navigate to the tab containing the invalid form field
            const tabContent = document.querySelector(tab.dataset.tabsTarget);
            for (const input of tabContent.querySelectorAll('input, select, textarea')) {
                input.addEventListener('invalid', () => this.setActiveTab(tab));
            }
        }
    }

    setActiveTab(tabItem) {
        if (this.#activeTab !== null) {
            this.#activeTab.setAttribute('aria-selected', 'false');
            document.querySelector(this.#activeTab.dataset.tabsTarget).hidden = true;
        }
        this.#activeTab = tabItem;
        this.#activeTab.setAttribute('aria-selected', 'true');
        document.querySelector(this.#activeTab.dataset.tabsTarget).hidden = false;
    }
}

function initTabs() {
    for (const item of document.querySelectorAll('[data-tabs-toggle]')) {
        const tabs = new Tabs(item.querySelectorAll('[role="tab"]'));
    }
}

initTabs();
